import { ReactNode, createContext, useContext, useState } from 'react';
import { DetailsModal, DetailsTagConcept } from 'app/components/editor/sidebar/tags/Modal/DetailsModal';
import { TagWithMetadata } from 'entities/tag';
import { resolveConceptLabel } from 'app/utils/tag-utils';
import { useDocumentParams } from 'app/router/params';
import { useTagDisplay } from 'app/state/contexts/TagContext';

const TagDetailsModalContext = createContext<{ showTagDetails: (tag: TagWithMetadata) => void } | null>(null);

export const useTagDetailsModal = () => {
  const context = useContext(TagDetailsModalContext);
  if (!context) throw new Error('useTagDetailsModal must be used inside TagDetailsModalProvider');
  return context;
};

export const TagDetailsModalProvider = ({ children }: { children: ReactNode }) => {
  const [detailsModalTag, setDetailsModalTag] = useState<TagWithMetadata | null>(null);
  const { documentId } = useDocumentParams();
  const { tagLanguage } = useTagDisplay();

  const showTagDetails = (tag: TagWithMetadata) => setDetailsModalTag(tag);

  const tagConcept: DetailsTagConcept | null = detailsModalTag && {
    id: detailsModalTag.id,
    name: detailsModalTag.concept?.name ?? '',
    conceptType: detailsModalTag.concept?.conceptType ?? undefined,
    label: resolveConceptLabel({ languages: detailsModalTag.concept?.labels ?? {}, currentLang: tagLanguage }),
    notes: detailsModalTag.notes ?? undefined,
  };

  return (
    <TagDetailsModalContext.Provider value={{ showTagDetails }}>
      {children}
      <DetailsModal show={!!detailsModalTag} tagConcept={tagConcept} documentSuperId={Number(documentId)} onClose={() => setDetailsModalTag(null)} />
    </TagDetailsModalContext.Provider>
  );
};
